import axios from '../../axios'

export default {
  async getListMenu({ commit }) {
    let {data} = await axios.get('/auth/getMenu')
    commit('SET_MENU',data.menu)
    commit('SET_MENU_TABLE',data.table)
  },
  async getListRol({ commit }) {
    let {data} = await axios.get('/auth/getRBM')
    commit('SET_ROL_TABLE',data.data)
  },
  async getListEmpresa({ commit }) {
    let {data} = await axios.get('/auth/getCompanies')
    commit('SET_EMPRESA_TABLE',data.data)
  },
  async getListUser({ commit }) {
    let {data} = await axios.get('/auth/list')
    commit('SET_USER_TABLE',data.detail)
  },
  async getCompanies({ commit }) {
    let {data} = await axios.get('/auth/getCompanies')
    commit('SET_COMPANY_TABLE',data.detail)
  },
}
